import React, { useState, useEffect } from 'react';
import { getPageContent, subscribeToPage } from '../firebase/firebase-config';

function HolidayHomework() {
  const [content, setContent] = useState({ session: '2025-26', homeworkItems: [], sliderImages: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await getPageContent('holidayHomework');
        setContent(data);
      } catch (error) { console.error(error); }
      finally { setLoading(false); }
    };
    loadData();
    const unsubscribe = subscribeToPage('holidayHomework', (data) => { if (data) setContent(data); });
    return () => unsubscribe();
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="homework-page">
      {content.sliderImages && content.sliderImages.length > 0 && (
        <div className="page-banner"><img src={content.sliderImages[0].url} alt="Holiday Homework" /><div className="banner-overlay"><h1>Holiday Homework</h1><p>Session {content.session}</p></div></div>
      )}
      <div className="container">
        <div className="homework-grid">
          {(content.homeworkItems || []).map((item) => (
            <div key={item.id} className="homework-card">
              <div className="homework-header"><span className="homework-class">{item.class}</span><span className="homework-holiday">{item.holiday}</span></div>
              <p className="homework-desc">{item.description}</p>
              {item.file ? <a href={item.file.url} download className="download-btn">📥 Download Homework</a> : <span className="not-available">No file uploaded</span>}
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .homework-page { background: #f8fafc; min-height: 100vh; }
        .page-banner { position: relative; height: 300px; overflow: hidden; }
        .page-banner img { width: 100%; height: 100%; object-fit: cover; }
        .banner-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; flex-direction: column; align-items: center; justify-content: center; color: white; text-align: center; }
        .banner-overlay h1 { font-size: 48px; margin-bottom: 10px; }
        .container { max-width: 1200px; margin: 0 auto; padding: 60px 20px; }
        .homework-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 25px; }
        .homework-card { background: white; border-radius: 12px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); transition: transform 0.3s; }
        .homework-card:hover { transform: translateY(-3px); }
        .homework-header { display: flex; justify-content: space-between; margin-bottom: 15px; }
        .homework-class { background: #1a3a6b; color: white; padding: 4px 12px; border-radius: 20px; font-size: 12px; }
        .homework-holiday { background: #f59e0b; color: white; padding: 4px 12px; border-radius: 20px; font-size: 12px; }
        .homework-desc { color: #475569; line-height: 1.6; margin-bottom: 15px; }
        .download-btn { display: inline-block; background: #1a3a6b; color: white; padding: 8px 16px; border-radius: 8px; text-decoration: none; transition: all 0.3s; }
        .download-btn:hover { background: #f59e0b; }
        .not-available { color: #94a3b8; font-style: italic; }
        .loading { display: flex; justify-content: center; align-items: center; min-height: 60vh; }
        .spinner { width: 50px; height: 50px; border: 4px solid #e2e8f0; border-top-color: #1a3a6b; border-radius: 50%; animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) { .banner-overlay h1 { font-size: 32px; } .homework-header { flex-direction: column; gap: 8px; } }
      `}</style>
    </div>
  );
}
export default HolidayHomework;